<template>
  <div
    class="form-group"
    :class="{ 'form-error': error, 'with-sub-label': subLabel != null }"
  >
    <label :for="id" v-if="label != null">{{ label }}</label>
    <div v-if="subLabel" class="sub-label">
      <small>{{ subLabel }}</small>
    </div>
    <input
      v-if="$attrs.type != 'textarea'"
      ref="input"
      :type="$attrs.type ? $attrs.type : 'text'"
      :placeholder="placeholder"
      :value="value"
      v-bind="$attrs"
      v-on="listeners"
      @change="handleFileChange"
    />
    <textarea
      v-else
      :placeholder="placeholder"
      :value="value"
      v-bind="$attrs"
      v-on="listeners"
      style="resize: vertical"
    ></textarea>
    <p class="error-message" v-if="error">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "input-text",
  inheritAttrs: false,
  props: {
    id: {
      default: "",
      type: String,
    },
    label: {
      default: null,
      type: String,
    },
    subLabel: {
      default: null,
      type: String,
    },
    placeholder: {
      default: null,
      type: [String, Number],
    },
    value: {
      default: "",
      type: [String, Number],
    },
    icon: {
      default: null,
      type: String,
    },
    error: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: "Invalid input",
      type: String,
    },
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners,
        input: (evt) => {
          this.$emit("input", evt.target.value);
        },
        focus: (evt) => {
          this.$emit("focus", evt);
        },
        blur: (evt) => {
          this.$emit("blur", evt);
        },
      };
    },
  },
  methods: {
    handleFileChange: function () {
      if (this.$attrs.type == "file") {
        this.$emit("file-change", this.$refs.input.files);
      }
    },
  },
};
</script>
